export const API_BASE    = process.env.REACT_APP_API_URL || "http://localhost:8080";
export const TOKEN_KEY   = "returnob_token";
export const USER_KEY    = "returnob_user";
export const REFRESH_KEY = "returnob_refresh";
export const COLORS = {
  night:"#0A1F3D", royal:"#1263B0", cyan:"#1CBCD3",
  gold:"#C9922A", goldL:"#FBF4E8", cyanL:"#E0F7FA",
  royalL:"#E3F2FD", white:"#FFFFFF", bg:"#F7F9FC",
  text:"#1E293B", sub:"#64748B", border:"#E2E8F0",
};
export const OBJECT_CATEGORIES = [
  { id: "ELECTRONIQUE",        label: "Électronique" },
  { id: "DOCUMENTS_IDENTITE",  label: "Documents d'identité" },
  { id: "BAGAGES",             label: "Bagages" },
  { id: "BIJOUX_MONTRES",      label: "Bijoux / Montres" },
  { id: "VETEMENTS",           label: "Vêtements" },
  { id: "CLES",                label: "Clés" },
  { id: "PORTEFEUILLE_SAC",    label: "Portefeuille / Sac" },
  { id: "AUTRE",               label: "Autre" },
];
export const TRANSACTION_TYPES = [
  { id: "REMISE_ARGENT",               label: "Remise d'argent" },
  { id: "DEPOT_BIEN",                  label: "Dépôt d'un bien" },
  { id: "TRANSMISSION_RESPONSABILITE", label: "Transmission de responsabilité" },
  { id: "ACCORD_VERBAL",               label: "Accord verbal" },
  { id: "RECONNAISSANCE_DETTE",        label: "Reconnaissance de dette" },
  { id: "AUTRE",                       label: "Autre" },
];
export const OPERATORS = [
  { id: "MTN",    label: "MTN Mobile Money", color: "#FFCC00", bg: "#FFFCE0" },
  { id: "ORANGE", label: "Orange Money",     color: "#FF6600", bg: "#FFF4EE" },
];
export const DOSSIER_STATUS_CONFIG = {
  EN_RECHERCHE:       { label: "En recherche",              color: "#1CBCD3" },
  MATCHING_EN_COURS:  { label: "Correspondance !",          color: "#C9922A" },
  PREUVES_EN_COURS:   { label: "Preuves requises",          color: "#C9922A" },
  DEVIS_ENVOYE:       { label: "Devis à confirmer",    color: "#C9922A" },
  RESTITUTION_ACTIVE: { label: "Restitution active",        color: "#1263B0" },
  REMIS:              { label: "Remis",                     color: "#1263B0" },
  CLOTURE:            { label: "Clôturé",        color: "#1263B0" },
  NON_RECLAME:        { label: "Non réclamé",    color: "#64748B" },
  SUSPENDU:           { label: "Suspendu",                  color: "#EF4444" },
};

export const COLORS_PALETTE = [
  { id: "noir",   label: "Noir",    hex: "#1a1a1a" },
  { id: "blanc",  label: "Blanc",   hex: "#f5f5f5" },
  { id: "bleu",   label: "Bleu",    hex: "#2563EB" },
  { id: "rouge",  label: "Rouge",   hex: "#DC2626" },
  { id: "vert",   label: "Vert",    hex: "#16A34A" },
  { id: "jaune",  label: "Jaune",   hex: "#FBBF24" },
  { id: "marron", label: "Marron",  hex: "#92400E" },
  { id: "gris",   label: "Gris",    hex: "#6B7280" },
  { id: "orange", label: "Orange",  hex: "#EA580C" },
  { id: "argent", label: "Argent",  hex: "#94A3B8" },
];
